import React, { useState, useEffect } from 'react';
import { TAB_CONFIG } from '../tabs';

const API_BASE = "https://adria.terrier-ule.ts.net";

const ALL_TABS = [...TAB_CONFIG];

const EMPTY_FORM = { tenant_id: '', name: '', username: '', password: '', tabs: ['billing', 'monthly', 'ble'], template: 'residential' };

const TEMPLATES = [
  { key: 'residential', label: '🏠 주택관리' },
  { key: 'parking',     label: '🚗 주차관리' },
  { key: 'storage',     label: '📦 무인창고' },
  { key: 'store',       label: '🏪 무인상점' },
];

export default function SuperAdmin({ token, onLogout }) {
  const [tenants,       setTenants]       = useState([]);
  const [loading,       setLoading]       = useState(true);
  const [showForm,      setShowForm]      = useState(false);
  const [editMode,      setEditMode]      = useState(false);   // true = 수정, false = 신규
  const [form,          setForm]          = useState(EMPTY_FORM);
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const [error,         setError]         = useState('');
  const [success,       setSuccess]       = useState('');

  const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };

  const fetchTenants = async () => {
    setLoading(true);
    try {
      const res  = await fetch(`${API_BASE}/api/auth/tenants`, { headers });
      const data = await res.json();
      setTenants(Array.isArray(data) ? data : []);
    } catch { setError('테넌트 목록 로드 실패'); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchTenants(); }, []);

  const toggleTab = (tab) => {
    setForm(f => ({
      ...f,
      tabs: f.tabs.includes(tab) ? f.tabs.filter(t => t !== tab) : [...f.tabs, tab],
    }));
  };

  const toggleActive = async (tenantId, current) => {
    try {
      await fetch(`${API_BASE}/api/auth/tenants/${tenantId}`, {
        method: 'PATCH', headers, body: JSON.stringify({ is_active: !current }),
      });
      fetchTenants();
    } catch { setError('변경 실패'); }
  };

  const openCreate = () => {
    setEditMode(false);
    setForm(EMPTY_FORM);
    setShowForm(true);
    setError(''); setSuccess('');
  };

  const openEdit = (t) => {
    setEditMode(true);
    setForm({ tenant_id: t.tenant_id, name: t.tenant_name, username: '', password: '', tabs: t.tabs || [], template: t.template || 'residential' });
    setShowForm(true);
    setError(''); setSuccess('');
  };

  const handleSubmit = async () => {
    setError(''); setSuccess('');
    if (editMode) {
      // 수정: 입력된 항목만 전송
      const body = { tabs: form.tabs, template: form.template };
      if (form.name)     body.name     = form.name;
      if (form.username) body.username = form.username;
      if (form.password) body.password = form.password;
      try {
        const res  = await fetch(`${API_BASE}/api/auth/tenants/${form.tenant_id}`, {
          method: 'PATCH', headers, body: JSON.stringify(body),
        });
        const data = await res.json();
        if (!res.ok) { setError(data.detail || '수정 실패'); return; }
        setSuccess(`✅ ${form.name || form.tenant_id} 수정 완료`);
        setShowForm(false);
        fetchTenants();
      } catch { setError('서버 오류'); }
    } else {
      // 신규 생성
      if (!form.tenant_id || !form.name || !form.username || !form.password) {
        setError('모든 항목을 입력하세요'); return;
      }
      try {
        const res  = await fetch(`${API_BASE}/api/auth/tenants`, {
          method: 'POST', headers, body: JSON.stringify(form),
        });
        const data = await res.json();
        if (!res.ok) { setError(data.detail || '생성 실패'); return; }
        setSuccess(`✅ ${form.name} 테넌트 생성 완료`);
        setShowForm(false);
        fetchTenants();
      } catch { setError('서버 오류'); }
    }
  };

  const handleDelete = async (tenantId) => {
    try {
      const res  = await fetch(`${API_BASE}/api/auth/tenants/${tenantId}`, { method: 'DELETE', headers });
      const data = await res.json();
      if (!res.ok) { setError(data.detail || '삭제 실패'); return; }
      setSuccess('✅ 테넌트 삭제 완료');
      setDeleteConfirm(null);
      fetchTenants();
    } catch { setError('서버 오류'); }
  };

  return (
    <div style={{ padding: '10px', fontFamily: '"Pretendard", sans-serif', backgroundColor: '#f3f4f6', minHeight: '100vh', maxWidth: '500px', margin: '0 auto' }}>

      {/* 헤더 */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
        <div>
          <span style={{ fontSize: '18px', fontWeight: 'bold', color: '#1f2937' }}>🛠 슈퍼관리자</span>
          <span style={{ fontSize: '12px', color: '#6b7280', marginLeft: '8px' }}>테넌트 관리</span>
        </div>
        <button onClick={onLogout} style={{ fontSize: '11px', color: '#6b7280', background: 'none', border: 'none', cursor: 'pointer' }}>
          로그아웃
        </button>
      </div>

      {error   && <div style={{ background: '#fee2e2', color: '#dc2626', padding: '10px', borderRadius: '10px', marginBottom: '10px', fontSize: '13px' }}>{error}</div>}
      {success && <div style={{ background: '#dcfce7', color: '#16a34a', padding: '10px', borderRadius: '10px', marginBottom: '10px', fontSize: '13px' }}>{success}</div>}

      {/* 테넌트 목록 */}
      <div style={{ background: '#fff', borderRadius: '15px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', marginBottom: '15px', overflow: 'hidden' }}>
        <div style={{ padding: '15px', borderBottom: '1px solid #f3f4f6', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontWeight: 'bold', fontSize: '14px' }}>테넌트 목록</span>
          <button onClick={openCreate}
            style={{ padding: '6px 14px', backgroundColor: '#4f46e5', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '12px', cursor: 'pointer' }}>
            + 신규 테넌트
          </button>
        </div>

        {loading ? (
          <div style={{ padding: '20px', textAlign: 'center', color: '#9ca3af', fontSize: '13px' }}>로딩 중...</div>
        ) : tenants.length === 0 ? (
          <div style={{ padding: '20px', textAlign: 'center', color: '#9ca3af', fontSize: '13px' }}>등록된 테넌트 없음</div>
        ) : tenants.map(t => (
          <div key={t.tenant_id}>
            <div style={{ padding: '15px', borderBottom: '1px solid #f9fafb' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <div style={{ fontWeight: 'bold', fontSize: '14px', color: t.is_active ? '#1f2937' : '#9ca3af' }}>
                    {t.tenant_name}
                    {!t.is_active && <span style={{ marginLeft: '6px', fontSize: '11px', color: '#ef4444' }}>비활성</span>}
                  </div>

                </div>
                <div style={{ display: 'flex', gap: '5px' }}>
                  <button onClick={() => openEdit(t)}
                    style={{ padding: '5px 8px', fontSize: '11px', borderRadius: '6px', border: 'none', cursor: 'pointer', backgroundColor: '#f3f4f6', color: '#4f46e5' }}>
                    ✏️ 수정
                  </button>
                  <button onClick={() => toggleActive(t.tenant_id, t.is_active)}
                    style={{ padding: '5px 8px', fontSize: '11px', borderRadius: '6px', border: 'none', cursor: 'pointer',
                             backgroundColor: t.is_active ? '#fee2e2' : '#dcfce7',
                             color: t.is_active ? '#dc2626' : '#16a34a' }}>
                    {t.is_active ? '비활성화' : '활성화'}
                  </button>


                </div>
              </div>


            </div>
          </div>
        ))}
      </div>

      {/* 신규생성 / 수정 폼 */}
      {showForm && (
        <div style={{ background: '#fff', borderRadius: '15px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', padding: '15px' }}>
          <div style={{ fontWeight: 'bold', fontSize: '14px', marginBottom: '12px' }}>
            {editMode ? '✏️ 테넌트 수정' : '신규 테넌트 등록'}
          </div>

          {/* 테넌트 ID — 신규만 편집 가능 */}
          <div style={{ marginBottom: '10px' }}>
            <label style={{ fontSize: '11px', color: '#6b7280', display: 'block', marginBottom: '4px' }}>테넌트 ID</label>
            <input type="text" value={form.tenant_id}
              onChange={e => !editMode && setForm(p => ({ ...p, tenant_id: e.target.value }))}
              placeholder="테넌트 ID (예: GREENVILL_01)"
              style={{ width: '100%', padding: '10px', borderRadius: '8px', fontSize: '13px', boxSizing: 'border-box', outline: 'none',
                       border: '1px solid #d1d5db', backgroundColor: editMode ? '#f9fafb' : '#fff', color: editMode ? '#9ca3af' : '#111' }} />
          </div>

          {/* 건물명 */}
          <div style={{ marginBottom: '10px' }}>
            <label style={{ fontSize: '11px', color: '#6b7280', display: 'block', marginBottom: '4px' }}>건물명</label>
            <input type="text" value={form.name}
              onChange={e => setForm(p => ({ ...p, name: e.target.value }))}
              placeholder="건물명 (예: 그린빌)"
              style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '13px', boxSizing: 'border-box', outline: 'none' }} />
          </div>

          {/* 관리자 아이디 */}
          <div style={{ marginBottom: '10px' }}>
            <label style={{ fontSize: '11px', color: '#6b7280', display: 'block', marginBottom: '4px' }}>
              관리자 아이디{editMode && <span style={{ color: '#9ca3af' }}> (변경 시만 입력)</span>}
            </label>
            <input type="text" value={form.username}
              onChange={e => setForm(p => ({ ...p, username: e.target.value }))}
              placeholder="관리자 아이디"
              style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '13px', boxSizing: 'border-box', outline: 'none' }} />
          </div>

          {/* 암호 */}
          <div style={{ marginBottom: '10px' }}>
            <label style={{ fontSize: '11px', color: '#6b7280', display: 'block', marginBottom: '4px' }}>
              암호{editMode && <span style={{ color: '#9ca3af' }}> (변경 시만 입력)</span>}
            </label>
            <input type="password" value={form.password}
              onChange={e => setForm(p => ({ ...p, password: e.target.value }))}
              placeholder={editMode ? '변경할 암호' : '초기 암호'}
              style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '13px', boxSizing: 'border-box', outline: 'none' }} />
          </div>

          {/* 템플릿 선택 */}
          <div style={{ marginBottom: '12px' }}>
            <label style={{ fontSize: '11px', color: '#6b7280', display: 'block', marginBottom: '6px' }}>템플릿</label>
            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
              {TEMPLATES.map(t => (
                <button key={t.key} onClick={() => setForm(p => ({ ...p, template: t.key }))}
                  style={{ padding: '6px 12px', borderRadius: '8px', border: 'none', cursor: 'pointer', fontSize: '12px',
                           backgroundColor: form.template === t.key ? '#0f766e' : '#e5e7eb',
                           color: form.template === t.key ? '#fff' : '#4b5563' }}>
                  {t.label}
                </button>
              ))}
            </div>
          </div>

          {/* 허용 탭 */}
          <div style={{ marginBottom: '12px' }}>
            <label style={{ fontSize: '11px', color: '#6b7280', display: 'block', marginBottom: '6px' }}>허용 탭</label>
            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
              {ALL_TABS.map(tab => (
                <button key={tab.key} onClick={() => toggleTab(tab.key)}
                  style={{ padding: '6px 12px', borderRadius: '8px', border: 'none', cursor: 'pointer', fontSize: '12px',
                           backgroundColor: form.tabs.includes(tab.key) ? '#4f46e5' : '#e5e7eb',
                           color: form.tabs.includes(tab.key) ? '#fff' : '#4b5563' }}>
                  {tab.label}
                </button>
              ))}
            </div>
          </div>

          <div style={{ display: 'flex', gap: '8px' }}>
            <button onClick={handleSubmit}
              style={{ flex: 1, padding: '12px', backgroundColor: '#4f46e5', color: '#fff', border: 'none', borderRadius: '10px', fontWeight: 'bold', fontSize: '13px', cursor: 'pointer' }}>
              {editMode ? '수정 완료' : '등록'}
            </button>
            <button onClick={() => setShowForm(false)}
              style={{ flex: 1, padding: '12px', backgroundColor: '#e5e7eb', color: '#4b5563', border: 'none', borderRadius: '10px', fontWeight: 'bold', fontSize: '13px', cursor: 'pointer' }}>
              취소
            </button>
          </div>
          {editMode && (
            <div style={{ marginTop: '10px' }}>
              {deleteConfirm === form.tenant_id ? (
                <div style={{ padding: '12px', backgroundColor: '#fff1f2', borderRadius: '10px', border: '1px solid #fecdd3' }}>
                  <div style={{ fontSize: '13px', color: '#dc2626', fontWeight: 'bold', marginBottom: '4px' }}>⚠️ 완전 삭제</div>
                  <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '10px' }}>
                    {form.name || form.tenant_id} 테넌트와 관련 유저를 DB에서 완전히 삭제합니다. 복구 불가능합니다.
                  </div>
                  <div style={{ display: 'flex', gap: '6px' }}>
                    <button onClick={() => handleDelete(form.tenant_id)}
                      style={{ flex: 1, padding: '8px', backgroundColor: '#dc2626', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '12px', cursor: 'pointer', fontWeight: 'bold' }}>
                      삭제 확인
                    </button>
                    <button onClick={() => setDeleteConfirm(null)}
                      style={{ flex: 1, padding: '8px', backgroundColor: '#e5e7eb', color: '#4b5563', border: 'none', borderRadius: '8px', fontSize: '12px', cursor: 'pointer' }}>
                      취소
                    </button>
                  </div>
                </div>
              ) : (
                <button onClick={() => setDeleteConfirm(form.tenant_id)}
                  style={{ width: '100%', padding: '10px', backgroundColor: '#fff1f2', color: '#dc2626', border: '1px solid #fecdd3', borderRadius: '10px', fontSize: '12px', cursor: 'pointer' }}>
                  🗑 이 테넌트 삭제
                </button>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
